module.exports = __webpack_public_path__ + "static/media/217RO.a0bee34c.jpg";